import {CSSProperties} from 'react'

export function blendHexColors(colorA: string, colorB: string, amount: number): string {
  const [rA, gA, bA] = hexToRGB(colorA)
  const [rB, gB, bB] = hexToRGB(colorB)
  const r = Math.round(rA + (rB - rA) * amount)
    .toString(16)
    .padStart(2, '0')
  const g = Math.round(gA + (gB - gA) * amount)
    .toString(16)
    .padStart(2, '0')
  const b = Math.round(bA + (bB - bA) * amount)
    .toString(16)
    .padStart(2, '0')
  return '#' + r + g + b
}

export function hslToHex(h: number, s: number = 100, l: number = 50): string {
  l /= 100
  const a = (s * Math.min(l, 1 - l)) / 100
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0') // convert to Hex and prefix "0" if needed
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

export function hexToRGB(hex: string): [number, number, number] {
  const aRgbHex = hex.replace('#', '').match(/.{1,2}/g)
  if (!aRgbHex) return [0, 0, 0]
  const aRgb: [number, number, number] = [
    parseInt(aRgbHex[0], 16),
    parseInt(aRgbHex[1], 16),
    parseInt(aRgbHex[2], 16),
  ]
  return aRgb
}

export function rgbToHsl(r: number, g: number, b: number): [number, number, number] {
  r /= 255
  g /= 255
  b /= 255
  const cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin
  let h = 0,
    s = 0,
    l = 0
  if (delta == 0) h = 0
  else if (cmax == r) h = ((g - b) / delta) % 6
  else if (cmax == g) h = (b - r) / delta + 2
  else h = (r - g) / delta + 4
  h = Math.round(h * 60)
  if (h < 0) h += 360
  l = (cmax + cmin) / 2
  s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1))
  s = +(s * 100).toFixed(1)
  l = +(l * 100).toFixed(1)
  return [h, s, l]
}

export function goodBadLabelStyle(s: number): CSSProperties {
  const style: CSSProperties = {}
  // style.opacity = 0.5;
  style.backgroundColor = blendHexColors('#ff0315', '#a4ee00', s)
  if (s === 0) style.textDecoration = 'line-through'
  if (s === 1) style.boxShadow = '0 0 4px 2px rgba(255, 255, 0, 0.35)'
  if (s < 0.5) style.color = 'white'
  style.transition = 'background-color 0.5s, color 0.5s, box-shadow 0.5s'
  return style
}
